module.exports = __webpack_public_path__ + "img/petdog2.30ed9d2d.jpg";